import React, {Fragment, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';


import './index.scss';

import * as routes from '../../constants/routes';


import {getDetailedBenefitCouponHash} from '../../redux/actions';
//assets
import logo from 'assets/logos/hot-new.svg';

import {cleanUpObject, getMediaPath} from "../../app/functions";

const Coupon = (props) =>{

    const data = useSelector(store => store.data.Coupon);

    const dispatch = useDispatch();

    useEffect(()=>{
        const search = window.location.search.split('=');
        let hash = null;
        if (search.length > 0){
            hash = search[1];
        }
        dispatch(getDetailedBenefitCouponHash({hash: hash}));
    },[]);

    //redux state
    const iconTypes = useSelector(store => cleanUpObject(store.config.IconTypes));

    const text = useSelector(store => store.config.Translations);

    let benefit_icon = null;
    let benefit_name = '';

    if(data) {
        benefit_icon = getMediaPath(iconTypes[data.type].imagePath);
        benefit_name = iconTypes[data.type].title;
    }

    return(
        <section className='coupon'>
            {data &&
            <Fragment>
                <div className='header'>
                    <img src={getMediaPath(logo)} alt='/'/>
                </div>
                <img className='main-image' src={getMediaPath(data.image.value)} alt={data.title}/>

                <div className='data-container'>
                    <div className='coupon-type'>
                        <img src={benefit_icon} alt='/'/>
                        <span>{benefit_name}</span>
                    </div>

                    <h2 className='title'>{data.title}</h2>
                    <div className='description'>{data.description}</div>

                    <div className='barcode-wrapper'>
                        <span className='instructions'>{text['coupon_instructions']}</span>
                        <img src={data.barcode} alt={data.title}/>
                    </div>
                </div>
            </Fragment>
            }
        </section>
    )
};

export default Coupon;
